import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

export interface ApiSwitchProps {
  url: string;
  isChecked: boolean;
  queryKey: any;
  field?: string;
  data?: any;
}

const useQuerySwitchState = ({url, queryKey, data}: ApiSwitchProps) => {
  const {setData} = useQueryHelpers();

  const {mutate, isLoading} = useApiMutation({
    method: 'PATCH',
    url,
    errorTitle: 'Erro ao alterar status',
    successTitle: 'Atualização de status',
    successMessage: 'Status atualizado com sucesso',
    onSuccess: (data) => setData(queryKey, data),
  });

  const handleRequest = (isChecked: boolean, field: string) => {
    mutate({...data, [field]: isChecked});
  };

  return {
    handleRequest,
    isLoading,
  };
};

export default useQuerySwitchState;
